export class StringUtils {

    /**
     * 文字列をトリムします。全角スペース文字もトリムの対象となります。
     * string.trim関数は環境に依存するため使用しません。
     * @param str トリム対象の文字列
     */
    public static trim(str: string) {
        return (str) ? str.replace(/(^[\s\u3000]+)|([\s\u3000]+$)/g, '') : str;
    }

    /**
     * 文字列をBoolean型に変換します。
     * null、true以外の文字列はfalseとなります。
     * @param data Boolean文字列
     */
    public static toBool(data): boolean {
        return (data && data.toLowerCase() === 'true');
    }

    /**
     * 文字列が数字かチェックし数字の場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrue（正常扱い）を返します。
     * @param str チェック対象の文字列
     */
    public static checkNumber(str: string):boolean {
        if (str) {
            return /^\d*$/.test(str);
        }
        return true;
    }

    /**
     * 文字列がカタカナかチェックしカタカナの場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrue（正常扱い）を返します。
     * @param str チェック対象の文字列
     */
    public static checkKatakana(str: string):boolean {
        if (str) {
            return /^[ァ-ヶー\s]{0,255}$/.test(str);
        }
        return true;
    }

    /**
     * 文字列が電話番号かチェックし電話番号の場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrue（正常扱い）を返します。
     * @param str チェック対象の文字列
     */
    public static checkTel(str: string):boolean {
        if (str) {
            return /^[0-9]{10,11}$/.test(str);
        }
        return true;
    }

    /**
     * 文字列が郵便番号（7桁の数字）かチェックし郵便番号の場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrue（正常扱い）を返します。
     * @param str チェック対象の文字列
     */
    public static checkPostalCode(str: string):boolean {
        if (str) {
            return /^[0-9]{7}$/.test(str);
        }
        return true;
    }

    /**
     * 文字列が全角文字の場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrueを返します。
     * @param str チェック対象の文字列
     */
    public static checkFullWidthCharacter(str: string):boolean {
        if (str) {
            return /^[^\x20-\x7e]*$/.test(str);
        }
        // 未入力の場合は正常扱いとする
        return true;
    }

    /**
     * 文字列が半角数字、または、半角英大文字の場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrueを返します。
     * @param str チェック対象の文字列
     */
    public static checkHalfWidthUppercaseAlphaNumeric(str: string):boolean {
        if (str) {
            return /^[A-Z0-9]*$/.test(str);
        }
        // 未入力の場合は正常扱いとする
        return true;
    }

    /**
     * ひらがな・アルファベット大文字の場合はtrue、それ以外の場合はfalseを返します。
     * 文字列が未入力の場合はtrueを返します。
     * @param str チェック対象の文字列
     */
    public static checkHiraganaAlphabet(str: string):boolean {
        if (str) {
            return /^[あ-んＡ-ＺA-Z]*$/.test(str);
        }
        // 未入力の場合は正常扱いとする
        return true;
    }
}